import type { EventCondition } from './types';
import { EventConditionType } from './types';
import type { AppStateController } from '../AppStateController';

type ConditionHandlers = {
  [K in EventConditionType]: (state: AppStateController, condition: Extract<EventCondition, { type: K }>) => boolean;
};
const conditionHandlers: ConditionHandlers = {
  [EventConditionType.WinStreakCooldown]: (state, condition) => {
    const timePassedSinceLastEvent = Date.now() - state.getLastWinStreakEndTime();
    return timePassedSinceLastEvent > condition.cooldown;
  },
  [EventConditionType.ReachedLevel]: (state, condition) => state.getLevelNumber() >= condition.level,
  [EventConditionType.GlobalTime]: (_, condition) => Date.now() >= condition.start && Date.now() <= condition.end,
  [EventConditionType.RaceEventCooldown]: (state, condition) => {
    const timePassedSinceLastEvent = Date.now() - state.getLastRaceEventEndTime();
    return timePassedSinceLastEvent > condition.cooldown;
  },
};

export function isConditionFulfilled<C extends EventCondition['type']>(
  state: AppStateController,
  condition: Extract<EventCondition, { type: C }>,
): boolean {
  const handler = conditionHandlers[condition.type];
  if (!handler) return true;
  return handler(state, condition);
}
